'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { ListHomeDonationHistoryDto } from '@generated/auth';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useSearchParams } from 'next/navigation';
import { AuthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { DesktopTitle } from '../_components/DesktopTitle';
import { DonationListItem } from './_components/DonationListItem';
import { EmptySection } from './_components/EmptySection';
import { PeriodFilter } from './_components/PeriodFilter';
import { PERIOD_FILTER_OPTIONS } from './constants';
const DonationsPage = () => {
  const $ = _c(27);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("period");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const searchParamsPeriod = t0;
  const isLogin = useAuthStore(_temp);
  let t1;
  if ($[2] !== searchParamsPeriod) {
    t1 = Number.isNaN(Number(searchParamsPeriod)) || searchParamsPeriod === undefined || searchParamsPeriod === null ? PERIOD_FILTER_OPTIONS[1].value : Number(searchParamsPeriod);
    $[2] = searchParamsPeriod;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const period = t1;
  let t2;
  if ($[4] !== period) {
    t2 = AuthQueryOptions["get:/wello/v2/auth/home-donation/history"]({
      query: {
        page: 1,
        size: 100,
        startSearchDate: period === 999 ? undefined : dayjs().subtract(period, "day").format("YYYY-MM-DD"),
        endSearchDate: dayjs().format("YYYY-MM-DD")
      }
    });
    $[4] = period;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isLogin || $[7] !== t2) {
    t3 = {
      ...t2,
      enabled: isLogin,
      select: _temp2,
      placeholderData: keepPreviousData
    };
    $[6] = isLogin;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: data_0,
    isLoading
  } = useQuery(t3);
  const isEmpty = data_0 && !isLoading && data_0?.totalCount < 1;
  const handleBusinessClick = _temp3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DesktopTitle className="mb-20">기부내역</DesktopTitle>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== period) {
    t5 = <PeriodFilter period={period} />;
    $[10] = period;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className={cn("mb-16 rounded-xsmall bg-Gray-50 px-20 py-12 font-400 text-Gray-600 typo-body4", "mobile-tablet:rounded-none")}>연계 시스템 지연에 의해 결제 내역 반영은 최대 3일이 소요될 수 있습니다.</p>;
    t7 = cn("flex flex-col gap-16 px-0 pb-[calc(20px+var(--safe-area-bottom,0px))]", "mobile-tablet:px-20");
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[14] !== data_0?.list) {
    t8 = data_0?.list.map(item_0 => {
      const {
        homeDonationId: home_donation_id,
        homeInstitutionLogoUrl: home_institution_logo_url,
        homeInstitutionName: home_institution_name,
        epayNumber: epay_number,
        homeDonationBusinessName: home_donation_business_name,
        homeDonationBusinessId: home_donation_business_id,
        thumbnailUrl: thumbnail_url,
        donationAmount: donation_amount,
        paidAt: paid_at,
        eventRewardProductNameList: event_reward_product_name_list,
        donationStatus: donation_status
      } = item_0;
      return <DonationListItem key={home_donation_id} institutionLogoUrl={home_institution_logo_url} institutionName={home_institution_name} epayNumber={epay_number} donationBusinessName={home_donation_business_name} donationBusinessId={home_donation_business_id} donationBusinessThumbnailUrl={thumbnail_url} donationAmount={donation_amount} paidAt={paid_at} onBusinessClick={() => handleBusinessClick(item_0)} eventRewardProductNameList={event_reward_product_name_list} isCancelled={donation_status === "CANCEL"} />;
    });
    $[14] = data_0?.list;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isLoading) {
    t9 = isLoading && Array.from({
      length: 10
    }).map(_temp4);
    $[16] = isLoading;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <ul className={t7}>{t8}{t9}</ul>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== isEmpty) {
    t11 = isEmpty ? <EmptySection className="mt-80" /> : null;
    $[21] = isEmpty;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t5) {
    t12 = <article className="flex h-full flex-col pb-20">{t4}{t5}{t6}{t10}{t11}</article>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t5;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};
export default DonationsPage;
function _temp(state) {
  return !!state.isLogin;
}
function _temp2(data) {
  return {
    list: data.context?.contents ?? [],
    totalCount: data.context?.totalCount ?? 0
  };
}
function _temp3(item) {
  trackGtmEvent(GTM_EVENT_TYPE.SELECT_ITEM, {
    currency: "KRW",
    value: item.donationAmount,
    local_name: item.homeInstitutionName,
    items: [{
      item_type: "\uACE0\uD5A5\uC0AC\uC5C5",
      item_list_name: "\uAE30\uBD80\uB0B4\uC5ED",
      item_list_id: item.homeDonationId.toString(),
      item_name: item.homeDonationBusinessName || "",
      quantity: 1,
      item_id: item.epayNumber,
      price: item.donationAmount,
      business_name: item.homeDonationBusinessName
    }]
  });
}
function _temp4(_, index) {
  return <DonationListItem key={index} loading={true} />;
}